import { cva } from '@/styled-system/css';

export const rangeRecipe = cva({
  base: {
    'appearance': 'none',
    'height': 'auto',
    'width': '100%',
    'marginBlock': 'Range.Root.margin.vert',
    'border': '0',
    'outline': 'none',

    '_focusVisible': {
      '&::-webkit-slider-thumb': {
        'outline': 'none',
        'boxShadow': '{shadows.Range.Handle.default}, {shadows.focus}',
        'borderColor': 'Range.Handle.border.active',
        'background': 'Range.Handle.bg.active',

        '&:is(:hover)': {
          borderColor: 'Range.Handle.border.activeHover',
          background: 'Range.Handle.bg.activeHover',
        },
      },

      '&::-moz-range-thumb': {
        'outline': 'none',
        'boxShadow': '{shadows.Range.Handle.default}, {shadows.focus}',
        'borderColor': 'Range.Handle.border.active',
        'background': 'Range.Handle.bg.active',

        '&:is(:hover)': {
          borderColor: 'Range.Handle.border.activeHover',
          background: 'Range.Handle.bg.activeHover',
        },
      },
    },

    '&::-webkit-slider-runnable-track': {
      height: 'Range.Track.height',
      background: 'Range.Track.bg.default',
      borderRadius: 'Range.Track',
      cursor: 'pointer',
      width: '100%',
    },

    '&::-moz-range-track': {
      height: 'Range.Track.height',
      background: 'Range.Track.bg.default',
      borderRadius: 'Range.Track',
      cursor: 'pointer',
      width: '100%',
    },

    '&::-webkit-slider-thumb': {
      width: 'Range.Handle',
      height: 'Range.Handle',
      background: 'Range.Handle.bg.default',
      borderColor: 'Range.Handle.border.default',
      borderStyle: 'solid',
      borderWidth: 'Range.Handle',
      borderRadius: 'Range.Handle',
      boxShadow: 'Range.Handle.default',
      cursor: 'grab',
      position: 'relative',
      display: 'flex',
      marginTop: 'calc({spacing.Range.Handle.margin.top} * -1)',
      appearance: 'none',
      boxSizing: 'border-box',
      transition: {
        _motionReduce: 'none',
        _motionSafe: 'box-shadow 200ms ease',
      },
    },

    '&::-moz-range-thumb': {
      width: 'Range.Handle',
      height: 'Range.Handle',
      background: 'Range.Handle.bg.default',
      borderColor: 'Range.Handle.border.default',
      borderStyle: 'solid',
      borderWidth: 'Range.Handle',
      borderRadius: 'Range.Handle',
      boxShadow: 'Range.Handle.default',
      cursor: 'grab',
      position: 'relative',
      display: 'flex',
      marginTop: 'calc({spacing.Range.Handle.margin.top} * -1)',
      appearance: 'none',
      boxSizing: 'border-box',
      transition: {
        _motionReduce: 'none',
        _motionSafe: 'box-shadow 200ms ease',
      },
    },
  },
  variants: {
    disabled: {
      true: {
        'opacity': 'disabled',

        '&::-webkit-slider-runnable-track': {
          cursor: 'auto',
        },

        '&::-moz-range-track': {
          cursor: 'auto',
        },

        '&::-webkit-slider-thumb': {
          cursor: 'auto',
        },

        '&::-moz-range-thumb': {
          cursor: 'auto',
        },
      },
      false: {
        '&::-webkit-slider-thumb': {
          _hover: {
            background: 'Range.Handle.bg.hover',
            boxShadow: 'Range.Handle.hover',
            borderColor: 'Range.Handle.border.hover',
          },

          _active: {
            background: 'Range.Handle.bg.pressed',
            borderColor: 'Range.Handle.border.pressed',
            boxShadow: '{shadows.focus}, {shadows.Range.Handle.default}',
            cursor: 'grabbing',
          },
        },

        '&::-moz-range-thumb': {
          _hover: {
            background: 'Range.Handle.bg.hover',
            boxShadow: 'Range.Handle.hover',
            borderColor: 'Range.Handle.border.hover',
          },

          _active: {
            background: 'Range.Handle.bg.pressed',
            borderColor: 'Range.Handle.border.pressed',
            boxShadow: '{shadows.focus}, {shadows.Range.Handle.default}',
            cursor: 'grabbing',
          },
        },
      },
    },
  },
});
